import Vue from 'vue'
//svg图标
import SvgIcon from './SvgIcon.vue'
Vue.component('SvgIcon', SvgIcon)
//el-link
import ElLink from './Element/ElLink.vue'
Vue.component('ElLink', ElLink)


// WEBPACK FOOTER //
// ./src/components/global.js